import { WithName } from '@mews-commander/types';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { TextKey } from '@mews-commander/enums';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { setBills } from '@mews-commander/legacy-entities/src/ducks/bills';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { BillNameDialog } from './BillNameDialog';
import { useCreateDefaultBillNameValuesFromAccountId } from './utils';

interface Props {
    active: boolean;
    onClose: () => void;
    accountId: string;
}

export const AddBillDialog = ({ accountId, active, onClose }: Props) => {
    const dispatch = useCommanderThunkDispatch();
    const enterpriseId = useCurrentEnterpriseId();

    const { mutateAsync } = useRepositoryMutation('bills', 'add', {
        onSuccess: (data) => {
            if (data.bills) dispatch(setBills(data.bills));
        },
    });

    const { defaultValues, accountName } = useCreateDefaultBillNameValuesFromAccountId(accountId);

    const onSubmit = async ({ name }: WithName) => {
        await mutateAsync({
            bills: [
                {
                    ownerId: accountId,
                    name,
                },
            ],
            enterpriseId,
        });
    };

    return (
        <BillNameDialog
            submitAction={onSubmit}
            active={active}
            onClose={onClose}
            titleTextKey={TextKey.CreateNewBillFor}
            submitButtonTextKey={TextKey.Create}
            defaultValues={defaultValues}
            titleSubstitutes={{ name: accountName }}
        />
    );
};
